import { configureStore } from '@reduxjs/toolkit';
// Import your slice reducers here when you create them
import elementReducer from '../features/element/elementSlice'; // Corrected import path
// import exampleReducer from '../features/example/exampleSlice';

export const store = configureStore({
  reducer: {
    // Add your reducers here:
    element: elementReducer, // Add the element reducer to the store
    // example: exampleReducer,
  },
});

export default store;
